export const AgentQuestions = {Recommendations: [
    {
      heading: "Peak Load",
      questions: [
        {
          text: "What was peak load last month and CAGR compared to previous year",
        },
        {
          text: "What is the expected morning and evening peak next month",
          highlights: ["next month"],
        },
        {
          text: "Plot daily peak load for next 5 months",
          highlights: ["next 5 months"],
        },
      ],
    },
    {
      heading: "Load",
      questions: [
        {
          text: "Plot load by time block for the previous month and compare it to previous year",
        },
        {
          text: "Plot load by time block for the next month along with expected deficit",
          highlights: ["next month"],
        },
      ],
    },
    {
      heading: "Price",
      questions: [
        {
          text: "What was the weighted average DAM and RTM price during morning peak hours last month; compare it to previous year",
        },
        {
          text: "Plot DAM price for all exchanges in the previous month",
          highlights: ["previous month"],
        },
      ],
    },
    {
      heading: "Generation",
      questions: [
        // {
        //   text: "What is the expected intrastate generation next month",
        //   highlights: ["next month"],
        // },
        {
          text: "List outages for the previous month",
          highlights: ["previous month"],
        },
      ],
    },
    {
      heading: "GSS",
      questions: [
        {
          text: "List the top 5 substations with highest load in Mar'25",
        },
        // {
        //   text: "List the top 5 substations with the highest growth in load over the past four years",
        //   highlights: ["four years"],
        // },
      ],
    },
  ],
  Load: [
    {
      heading: "Load",
      questions: [
        {
          heading: "Maximum Demand",
          text: "Which discom had the maximum demand last month",
          highlights: ["last month"],
        },
        {
          heading: "YOY Growth",
          text: "Which discom had the maximum YOY growth in demand last month",
          highlights: ["last month"],
        },
        {
          heading: "Historical Comparison",
          text: "Compare load of Jaipur discom in January for previous four years",
          highlights: ["Jaipur", "January", "four years"],
        },
      ],
    },
    {
      heading: "GSS",
      questions: [
        {
          heading: "Growth Analysis",
          text: "List the top 5 substations with the highest growth in load over the past four years",
          highlights: ["four years"],
        },
        {
          heading: "Regional Analysis",
          text: "Plot load for top 5 substations in Jaipur discom for last month",
          highlights: ["top 5", "Jaipur discom", "last month"],
        },
        {
          heading: "Growth Contribution",
          text: "Which substation had the highest contribution in load growth last month",
          highlights: ["last month"],
        },
      ],
    },
  ],
  "Peak Load": [
    {
      heading: "Compare Peak Load",
      questions: [
        {
          heading: "YOY",
          text: "Compare the peak demand for past 4 years",
          highlights: ["4 years"],
        },
        {
          heading: "YOY By Discom",
          text: "Compare the peak demand by Discom for past 4 years",
          highlights: ["4 years"],
        },
        {
          heading: "MOM",
          text: "Compare the peak demand for May and June for past 4 years",
          highlights: ["May and June", "4 years"],
        },
        {
          heading: "MOM by Discom",
          text: "Compare the peak demand by Discom for May and June for past 4 years",
          highlights: ["May and June", "4 years"],
        },
      ],
    },
    {
      heading: "Morning and Evening Peak",
      questions: [
        {
          heading: "YOY",
          text: "Compare the morning and evening peak demand for past 4 years",
          highlights: ["4 years"],
        },
        {
          heading: "YOY By Discom",
          text: "Compare the morning and evening peak demand by Discom for past 4 years",
          highlights: ["4 years"],
        },
        {
          heading: "MOM",
          text: "Compare the morning and evening peak demand for a month for past 4 years",
          highlights: ["4 years"],
        },
        // {
        //   heading: "MOM by Discom",
        //   text: "Compare the morning and evening peak demand by Discom for May and June for past 4 years",
        //   highlights: ["May and June", "4 years"],
        // },
      ],
    },
    {
      heading: "Peak Demand and Price",
      questions: [
        {
          heading: "YOY",
          text: "Compare the morning and evening peak demand for past 4 years and corresponding DAM price",
          highlights: ["4 years"],
        },
        {
          heading: "MOM",
          text: "Compare the morning and evening peak demand for May and June for past 4 years and corresponding DAM price",
          highlights: ["May and June", "4 years"],
        },
      ],
    },
  ],

  Generation: [
    {
      heading: "Generation",
      questions: [
        {
          heading: "Forecast Generation",
          text: "What is the expected intrastate generation next month split by source",
          highlights: ["next month"],
        },
        {
          heading: "Solar Profile",
          text: "Compare solar generation for next month and compare with previous years",
          highlights: ["next month", "previous years"],
        },
        {
          heading: "Power Portfolio",
          text: "What was the energy portfolio last month",
          highlights: ["last month"],
        },
      ],
    },
    {
      heading: "Outage",
      questions: [
        {
          heading: "List outages",
          text: "List outages for the previous month",
          highlights: ["previous month"],
        },
        {
          heading: "Frequent Outages",
          text: "Which generator had the most frequent outages last year",
          highlights: ["last year"],
        },
        {
          heading: "Maximum Outages",
          text: "List top 5 generators under outage by total duration of outage last year",
          highlights: ["top 5", "last year"],
        },
      ],
    },
  ],
  // Procurement: [
  //   {
  //     heading: "Price Analysis",
  //     questions: [
  //       { text: "Plot IEX DAM wt. avg price for yesterday" },
  //       { text: "How much power was procured from Collective in Apr'25?" }
  //     ]
  //   },
  //   {
  //     heading: "Source Analysis",
  //     questions: [
  //       { text: "How much power was procured from OA_GNA in Apr'25?" },
  //       { text: "How much power was procured from exchanges in April?" },
  //       { text: "Which supplier provided the most power last month?" }
  //     ]
  //   }
  // ],

  Forecast: [
    {
      heading: "Load",
      questions: [
        {
          heading: "15-minute Forecast",
          text: "Plot load by time block for the next month along with expected deficit",
          highlights: ["next month"],
        },
        {
          heading: "Compare",
          text: "Compare previous month's load forecast with actual values",
        },
      ],
    },
    {
      heading: "Peak Load",
      questions: [
        {
          heading: "Daily Peak",
          text: "Plot daily peak load for next 5 months",
          highlights: ["5 months"],
        },
        {
          heading: "Morning & Evening Peak",
          text: "What is the expected morning and evening peak next month",
          highlights: ["next month"],
        },
      ],
    },
    {
      heading: "Generation",
      questions: [
        {
          heading: "Generation Profile",
          text: "What is the generation profile next month",
          highlights: ["next month"],
        },
        {
          heading: "15-minute Forecast",
          text: "Plot generation profile by time block for next month",
          highlights: ["next month"],
        },
        // {
        //   heading: "Compare",
        //   text: "Compare previous month's forecast for state generation with actual values",
        // },
      ],
    },
  ],
  Exchange: [
    {
      heading: "Price Analysis",
      questions: [
        {
          heading: "Compare Exchanges",
          text: "Plot DAM price for all exchanges in the previous month",
          highlights: ["previous month"],
        },
        {
          heading: "Top Buyers and Sellers",
          text: "Who were the top buyers and sellers in IEX DAM yesterday?",
          highlights: ["yesterday"],
        },
        {
          heading: "Buy by Time of Day",
          text: "Plot top buyer's buy volume by time block for yesterday?",
          highlights: ["yesterday"],
        },
        {
          heading: "Price by Time of Day",
          text: "Compare the DAM price during morning and evening peak for past 4 years",
          highlights: ["4 years"],
        },
        {
          heading: "Max Price Occurrence",
          text: "List number of slots each day with maximum DAM price (₹10) in the previous month",
          highlights: ["previous month"],
        },

        {
          heading: "Buyer and Seller by Time of Day",
          text: "Who were the buyers and sellers during morning and evening peak in June last year?",
          highlights: ["June last year"],
        },

      ],
    },
    {
      heading: "Buyer and Seller Analysis",
      questions: [

      ],
    },
  ],
}